import { ArrayInput, SelectInput, SimpleFormIterator } from 'react-admin';
import { useBlockTypesContext } from '../../BlocksInput/BlockTypesProvider';

export interface ContentTypeDataBlocksInputProps {
  source: string;
}

const ContentTypeDataBlocksInput = ({ ...props }: ContentTypeDataBlocksInputProps) => {
  const { source } = props;
  const { blockTypes } = useBlockTypesContext();

  return (
    <ArrayInput source={source} fullWidth>
      <SimpleFormIterator fullWidth>
        <SelectInput source={source} fullWidth choices={blockTypes} />
      </SimpleFormIterator>
    </ArrayInput>
  );
}

export default ContentTypeDataBlocksInput;
